import { render, staticRenderFns } from "./QueensLabNotebookTask.vue?vue&type=template&id=f5089b0a&scoped=true&"
import script from "./QueensLabNotebookTask.vue?vue&type=script&lang=ts&"
export * from "./QueensLabNotebookTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5089b0a",
  null
  
)

export default component.exports